module.exports = __webpack_public_path__ + "img/02.2752d1b3.jpg";